export enum GraphAppType {
    Web = "Web",
    Native = "Native",
    SAML = "SAML"
}